import { useRef } from "react";
import { useParams } from "react-router-dom";
import * as L from "leaflet";
import { FormikProps } from "formik";
import { useTranslation } from "react-i18next";

import { usePoi, usePoiUpdateMutation } from "src/hooks";
import { useCase } from "src/hooks/useCase";
import { PoiForm, PoiFormData } from "src/forms/PoiForm";
import { isReadOnly } from "src/utils/permission.utils";

interface Props {
  map: L.Map;
  onClose: () => void;
}

export function PoiEditPage(props: Props) {
  const { t } = useTranslation();
  const { caseId = "", poiId = ""} = useParams<{ caseId: string; poiId: string }>();
  const formRef = useRef<FormikProps<PoiFormData> | null>(null);

  // async data fetch
  const { data: acase } = useCase(caseId);
  const { data: poi } = usePoi(caseId, poiId);

  // mutations
  const updateMutation = usePoiUpdateMutation(caseId, poiId);

  /**
   * Functions
   */
  async function handleSave(values: PoiFormData) {
    await updateMutation.mutateAsync(values);
  }

  return render();

  function render() {
    if (!acase || !poi) return null;

    return (
      <>
        <PoiForm
          key={poi.id}
          map={props.map}
          title={t("label.poiDetails")}
          readOnly={isReadOnly(acase.permissions.poi)}
          data={poi}
          markerStatus="active"
          isLoading={updateMutation.isLoading}
          errors={updateMutation.error?.response?.data}
          formRef={formRef}
          onClose={() => props.onClose()}
          onSubmit={handleSave}
        />
      </>
    );
  }
}
